<template>
    <div class="wrapper">
        <!-- <div :class="['ttl',borderShow?'':'borderShow']">
            <div class="ttl-icon1" @click="goBack">
                <img class="icon-back" :src="closeIcon"/>
            </div>
        </div> -->
        <div class="top_div">
            <img class="top_div_icon" :src="finishIcon"/>
            <span class="top_div_text">提交成功！</span>
        </div>

        <div class="message_div">
            <span class="message_div_text">电子发票将于3个工作日内发送到您的电子邮箱</span>
        </div>

        <div class="button_div">
            <div class="left_button" @click="goBack">
                <span class="left_button_text">返回</span>
            </div>
            <div class="right_button" @click="goToInvoiceHistory">
                <span class="right_button_text">开票历史</span>
            </div>
        </div>
    </div>

</template>

<script>
import storage from '../../utils/storage';
    export default {
        name: "successView",


        data () {
            return {
                borderShow:false,
                finishIcon:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAACGxJREFUWAnVmV1sHUcVx8/M7l4nqWKj1PXHTYprBDxAnQdSIWFVido4VopoJZSoeaCpVCSwkaBIlLoktsHCdhqnUIGERIDS0AQeWrUgEYlWiZ3IoQoCNSDFhQeKcE0TfyVEapCS3Lu7M/z/s97ra+f61k5tqx3Zd3fn45zfnjkzc2ZWyftM2dcPftTk4yZj7FZR6nNipVGJ3E6xVuS/omRUrP2T1uqMzngj4/d+5z/vRyVkLz1lh/vujEP1gLV2l2h9t2jJAlbEGEcJwEQo86hBa+Qjz8g46ryplHrFC+yr49u63lmq9iUB1w73NtrYa4fyL6nA20hlNgYk/xeTPC0K/0w2jC/iJX+jvPjw1Lbu0cU0Z51FAW86++za/LVrX0PtJ1VFps6G0SykVoDwEkm0YvLn9Dvh/KGlmR/HsDJumAgf+GJz+UmUPZNZt+6nF5q/dT0pXPj3PYE3Dh74ZOjJj2GZnXOs6XuiAGvz0VUAjUDQX61Vf0fvvxMrfdUxWVMJL7lTKftpYH4GPdOkMn6lJXQEeFcpsTpkv5YJ48cvtHa/lRSU/i0LXDvUez+onpfAb7C5MJFAy8BiUHBetDrmW+/4+OXGf8nDD88QlFYkL73kZbOjH4/C+EFYeS8MsBljoNBTqiIQCaMxsebLU9u7Ty0gZWGXqD114CE0OiKe2gB/c13uujCKR5U1T4e5+MUrn+9xllxI+EL5G/7QUxlUeHus0vuU7zU6FwM7xgVewF5Bu8em7t//+1LtS1q4brD/PqvVy/jf4LoOFlUerGrsUZPx912+96nxUsKWmlf9+kBW56On4VqP2hjEtDhdzdgr+N892dJ5er7MZMgW5W4aPvQJq+WIhWUdLAeVUnnAdkyfCR9bLliqpCzKpGzqgIs536ZuMpClCM3dzrFw9o2eddG7/u9UJmh1PktYrfI6lq9PbN//i/mNl/O5fujAV4wnPwF8hjMJfdrmwxN+VfTF8Xt6rqW65lg4ftf/Kvw0gcWruFkgNp0rDUsY6sBA7qROjiwajCxkSmF5LVi4dviZRhvlzmJVquNCgOmHb/jr6ZbuvcUNVvq+ZrD3GHr4EUyXbq7Gyjip/IrmqW1PjlJ3wcI2zLWjGxys+MgO47dNpDtWGnC+fKcTuh0DDQcmsqX1HPCG0wObsNrsddMXSuC5LO+/vLNzIq24WtcZnf0zDFzCuUrudYyAcMBBlH9AVfj1LibAtIJ5cSSu8F9cLcj5eqibDJzinHuCjYysp6WnR2M62Z02otMjFDyKKed/ad5qX6mbDG4ApsrJCFY/e5+/MQpls7MuYBkbxNoeT+utxLX25MEmq0wzYo+/XNqx72+ldETKHsei0g1jVroYxspmsmoT+5sROSUzA0M/q0YaKmv+XUrIcuTVnuh9SHx7Sq0LDmtfTtYNDXy2lFzHwKCKTAxfwUhWbUzEnULSJlmCz527p20m0ikl6tbzCGsD76hVttpey4msCW43Em8tJZEMWP3OFbORlYOuuRCjcjk38o9SAm7Kw2J0U16ZjBQWVaokchYTuRFe96z8eaFmjgVMLiVxdLOP6aPBhXnMRfDBeDapUfq3GvExeun7MqxukxP5H021fm+odM3ZXEZ+VslRTJhVwiA+CVFz6OrHJ1o6/zhbc+4dWYrZyIrgVqpdlIS6fJnYROVmB+WJeVbWZvZA6RdsELwyE4bO1VT05GCFsLBsMWxovzG1vfO5oqo33ZIlNbBjBCtdYmlJqRoE2m6tR8MqRFXH6gYPFKbFYmF3DPbuxsR5DEYBbOIGsFLORLZtasetBVMaZr2cOjad0tP++mKl8+6tNeYg1vcb7FYHYaUSUdbzd8yDrjnZtwvB+S/hZZWzsJIzsW271LL/hXlySz6SpTBQODGAVVuxYykwr9yDlWw9kzm9o/u3JjLtqDoLLbJeA7rmVN8uVuMAU74+AgUJLJzRWTaWRcNSjmMhKBOuZKVLIEJLM5Gv5VOuQpmfSy1dLzhoK7nU0vC19Th3eK5msP8HkHfEPaduoJZm2VS1Y0lNnDCe1Vr7Z9JBxyu2Klu2vPEz7AjLpwQ6aleEhgVdtyv1EezLnnBbK8LOWFYt0bLUTAbMEFuK2ciqtRedh7JJWsotgco2jV2d/lh53KT0Uut3f2WMaYMREkvzhXlmwTmTUxfyTRy3TS7SZ4t1OgYcCzimZLxMklWPn44uwj3OuyWQWxOcG/hWPVjcuNy9szShU/dg5RQW+Swv136hMjKQxW2XKA+MZGW0ZpD5ctoQeyo4u30UO9pys0Va3V0L0CLX1W1raNkbJr51WOomA1kKiYxg5aCT0M+8anPRhBtAOJHBXqrJy0V7CpUXcUNoLzKtKo47VCg7b9WyVEXdZHC7dliXbGRkGYyRpJrBvgG1JuiwNxD3YIukYvt2HErzau86ql/rr/cCOYut/l2MOcAkYDo03dL1FEmdhXmjgorD2Km6weeCk8C7S/vmEMtWMzmd0J0GSGQiW8pQAOauFOYecIMPpRztWKkeqRnq+3ZaeaWv1EWdbqaBMrKQKd0xU38BmA9eVfRzVD7hDubg73R6NOrnIQfLVzJRB3W5gQbd7iAFLGQq1lvw4TSTx0NhHJ60nm7AVh+vhEVVcFQltgvHSj90s0paeTmu2KfVbA2egI4+6HCnPoJDQRWbscALdlzY1vFWsZqbgFn4QT4MLAlM6A/VcSuBmZb9QLsaB9pqhQ60E2SRRX0ywE4bkVX5TwYGnwwQp5T7ZBDE8s2LLfv/meoudV3QJYorZ4/jGHat347R98H/KFMM/qH57FUMzfvCh0WFD4tWNeE7SL3btbzXh8XYTsAtRpRdpQ+L88H5XD/U12CVunsxn26VtW9ObO8aKyVnsXn/Bzx4rEZ13BdcAAAAAElFTkSuQmCC",
                closeIcon:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAAt1JREFUWAntlz+LGkEYxnUvIY1HUCvFxsYulWgKIbGySGz9CFaJnHf5An6B/OM25EPYiiSehaQRAmJnIQFNo2AlrM1pdPM+xglzw+3tzI4hcMyA7q77zjM/n33nnZ1QyDTjgHHAOGAcMA7cZwdOVP5cLpd7nkqlnlSr1R+9Xs9V6SvGNhoNy3GcF6SXnM1mP8X7Xtdhrxvi7wT7zHXdTjgcfkTHS/q8GQwGGzFO5jqbzT4knbf0qZHO9Xa7LQ2Hw28yfS2ZIMTsdrtTwNIRlzU6f1csFh/gQqWhD/pSnxq0oGlZ1qmshnRKJJPJKYk/JuGn5AoGyq/X61gikejO5/P9v/AbFM5uNpv3FPf6oIEul/T5LKshDQzBQqFwtVwuY4Bl0HQezWQyV9Pp9E5oOHsLrJ1Op8+73e4vkMs0aWCIjUYjl6A7IjScvgsasKvVSnQWsPVms7mVAWUxSsBBoI8Ji/GVgVWgPWA/BXEW46JJl7U/4Te/K5XKyWQy+UC/8pPILpfLZ4hstVofhXuAPVNNA2ixpgUMEQ9ozHw01FlUFJxrw0JEGxgiHo8+xMNGIpE6rY7S1QC6t7VAOSwKoaSJ1QMxB2f31aDdbitVA3EMdi290rEO//t4FIeREovF4sYEg7tscaG6Hac63fFbXGTM0AbGpDvAvuJyFpPuO0Hzy3ic0uYrFh8ZMK8YLeBDhYCzPCzKWp0c/TIej+ME/XcZh9O60IGrhBcsVYNzVg08qodWeQvksEfttXlYPFLkLN4x8K4hOB1DVQmSHsrAsrAsB48NrQSsCvsvoKWB8fJNk2a/U+CqgU3nF/1+33cFg9N42afUiArpEVXZBKgsHCUaiH832Oesyr4Oschzct4mLVana3RdYk/D7ygNTPsuh9y8piM0sQm9YNXAbxD+PvqgLzSgBU3a2zl8zNHOsc3P5/NlbNF1RaFBWi+hqatl+hsHjAPGAeOAceD+OPAbfN8R5938cTkAAAAASUVORK5CYII=",

            }
        },


        created() {

            storage.removeS("InvoicSuccess")
        },

        methods: {
            goBack() {
                this.$router.go(-1)
            },
            goToInvoiceHistory(){
                 this.$router.replace('/invoiceHistory')
            },
        }
    }
</script>

<style scoped>

    .wrapper {
        background-color: #FFF;
        flex-direction: column;
    }


    .ttl {
        /* justify-content: center; */
        width: 750px;
        height: 88px;
        flex-direction: row;
        align-items: center;
        background-color: #fff;
        border-bottom-width: 1px;
        border-bottom-color: rgb(220, 223, 230);
        /*rgb(224,224,224);*/
    }

    .iOS7 {
        padding-top: 40px;
        height: 128px;
    }

    .iPhoneX {
        padding-top: 80px;
        height: 168px;
    }
    .borderShow{
        border-bottom-color:#fff;
    }

    .ttl-icon1{
        width: 88px;
        height: 88px;
        justify-content: center;
        align-items: center;
        margin-right: 100px;
    }

    .icon-back {
        width: 44px;
        height: 44px;
    }

    .top_div{
        margin-top: 160px;
        display: flex;
        width: 750px;
        height: 80px;
        flex-direction: row;
        /* align-items: center; */
    }

    .top_div_icon{
        margin-left: 226px;
        width: 44px;
        height: 44px;
        margin-top: 12px;
    }

    .top_div_text{
        margin-left: 12px;
        /*  */
        height: 66px;
        width: 240px;
        color: #333333;
        font-size: 48px;
        text-align: left;
        line-height: 64px;
    }


    .message_div{
        margin-top: 14px;
        width: 750px;
        display: flex;
        height: 80px;
        justify-content: center;
    }


    .message_div_text{
        color: #999999;
        font-size: 28px;
        text-align: center;
        line-height: 40px;

    }


    .button_div{
        margin-top: 70px;
        flex-direction: row;
        width: 750px;
        display: flex;
        justify-content: center;
    }


    .left_button{
        margin-top: 4px;
        margin-left: 32px;
        height: 68px;
        width: 332px;
        border-radius: 8px;
        border-color: #0087FF;
        border-width: 1px;
        border-style: solid;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

    }

    .left_button_text{
        height: 40px;
        color: #0087FF;
        font-size: 28px;
        text-align: center;
        line-height: 38px;

    }


    .right_button{
        margin-top: 4px;
        margin-left: 20px;
        height: 68px;
        width: 332px;
        border-radius: 8px;
        background-color: #0087FF;
         display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

    }


    .right_button_text{
        height: 40px;
        color: #FFFFFF;
        font-size: 28px;
        text-align: center;
        line-height: 38px;

    }


</style>
